import { BaseMutations } from '@/store/base-mutations';
import { PurchaseOrders } from '@/modules/purchase-orders/types';
import EquipmentState from './state';

export default class EquipmentMutations extends BaseMutations<EquipmentState> {
  SET_EQUIPMENT(equipment: PurchaseOrders.Equipment[]) {
    this.state.equipment = equipment;
  }

  TOGGLE_LOADING_EQUIPMENT(toggle: boolean) {
    this.state.loading = toggle;
  }
}
